import Game from "../common/game";
import PlayNotComplete from "../../sports/football/exceptions/play-not-complete";
import FootballField from "./football-field";
import SportCodes from "../common/sport-codes";

export default class FootballGame extends Game {
    constructor(event) {
        super(event);
        this.field = new FootballField();
        this.plays = [];
        this.sportCode = SportCodes.Football;
    }

    async addPlay(play) {
        if (this.plays.length) {
            const last = this.getLastPlay();
            if (!last.isComplete()) {
                throw new PlayNotComplete();
            }
        }

        play.gameId = this.id;

        this.plays.push(play);
    }

    getLastPlay() {
        return this.plays.length ? this.plays[this.plays.length - 1] : null;
    }

    toJSON() {
        return super.toJSON([], ["plays"]);
    }
}
